import FormClient from "./FormClient/FormClient";
import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import { Container, Row, Col } from "react-bootstrap";

const FormManager = () => {
  return (
    <Container className="custom-margin-left mt-5 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start">
        <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        >
          <GenerateQuestion
            header="Dados proponente principal"
            subheader="O proponente principal é quem assume a responsabilidade pelo projeto ou proposta, sendo o responsável direto por sua execução e gestão."
          />
        </Col>
        <Col xs={1} sm={1} md={1} lg={1} className="d-none d-md-block"></Col>
        <Col className="mx-3 mx-md-0">
          <FormClient />
        </Col>
      </Row>
    </Container>
  );
};

export default FormManager;
